module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selects"
  }, [_c('Select', {
    attrs: {
      "value": _vm.monthValue,
      "options": _vm.months
    },
    on: {
      "input": _vm.onChangeMonth
    }
  }), _c('Select', {
    attrs: {
      "value": _vm.monthYear,
      "options": _vm.years
    },
    on: {
      "input": _vm.onChangeYear
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af7788d4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/components/filterselect/FilterSelectBlock.vue
// module id = 9c90000e76269059b4d0
// module chunks = 7